import type {UserState} from '@github-ui/swp-core/lib/utils/rendering-strategy'
import type {PersonalisationRule} from '../../types/components/personalisationRule'

type HeroCta = {fields: {href: string; text: string}}
type ResolvedHeroCta = {
  cta: HeroCta | undefined
  audienceCondition: PersonalisationRule['fields']['audienceCondition'] | undefined
}

export function resolveCtaWithPersonalisation(
  defaultCta: HeroCta,
  personalisationRules: PersonalisationRule[] | undefined,
  userState: UserState,
): ResolvedHeroCta & {cta: HeroCta}
export function resolveCtaWithPersonalisation(
  defaultCta: HeroCta | undefined,
  personalisationRules: PersonalisationRule[] | undefined,
  userState: UserState,
): ResolvedHeroCta
export function resolveCtaWithPersonalisation(
  defaultCta: HeroCta | undefined,
  personalisationRules: PersonalisationRule[] | undefined,
  userState: UserState,
): ResolvedHeroCta {
  const matchingRule = personalisationRules?.find(rule => matchesAudienceCondition(rule, userState))

  return {
    cta: matchingRule?.fields.link ?? defaultCta,
    audienceCondition: matchingRule?.fields.audienceCondition,
  }
}

function matchesAudienceCondition(rule: PersonalisationRule, userState: UserState): boolean {
  switch (rule.fields.audienceCondition) {
    case 'LOGGED_IN':
      return userState.isLoggedIn === true
    case 'COPILOT_EDU':
      return userState.hasCopilotEdu === true
    case 'COPILOT_FREE':
      return userState.hasCopilotFree === true
    case 'COPILOT_PRO':
      return userState.hasCopilotPro === true
    case 'COPILOT_PRO_PLUS':
      return userState.hasCopilotProPlus === true
    case 'COPILOT_MAX':
      return userState.hasCopilotMax === true
    case 'COPILOT_BUSINESS':
      return userState.hasCopilotBusiness === true
    case 'COPILOT_ENTERPRISE':
      return userState.hasCopilotEnterprise === true
    case 'TEAM_ADMIN':
      return userState.isTeamAdmin === true
    case 'ENTERPRISE_ADMIN':
      return userState.isEnterpriseAdmin === true
    case 'TEAM_MEMBER':
      return userState.isTeamMember === true
    case 'ENTERPRISE_MEMBER':
      return userState.isEnterpriseMember === true
    default:
      return false
  }
}
